import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/weryai_32.png")